import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useWatch } from 'react-hook-form';

import { CustomFormField } from 'app/views/layout/views/settings/views/customForms/customForms.types';

import { FormValues } from '../../../../../types';

import { FormFieldRow } from './components/formFieldRow';

type Props = {
  onRowMoved: (fromIndex: number, toIndex: number) => void;
  onDelete: (index: number) => void;
  canBeDeleted: (
    field: CustomFormField,
    index: number,
  ) => { result: boolean; message?: string };
};

export function FormFieldRows({
  onRowMoved,
  onDelete,
  canBeDeleted,
}: Props): JSX.Element {
  const fields = useWatch<FormValues, 'formFields'>({ name: 'formFields' });

  return (
    <>
      {fields?.map((field, index) => {
        const { result: isAllowedToDelete, message } = canBeDeleted(
          field,
          index,
        );

        const deleteButton = (
          <Tooltip content={message} disabled={isAllowedToDelete}>
            <IconButton
              icon="trash"
              variant="tertiary"
              type="button"
              onClick={() => {
                if (isAllowedToDelete) {
                  onDelete?.(index);
                }
              }}
              disabled={!isAllowedToDelete}
            />
          </Tooltip>
        );

        return (
          <FormFieldRow
            key={`${field.id}-${index}`}
            field={field}
            index={index}
            onOrderChange={onRowMoved}
            deleteButton={deleteButton}
          />
        );
      })}
    </>
  );
}
